// src/Auth/Logout.tsx
import React, { useEffect, useRef } from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const Logout: React.FC = () => {
    const auth = React.useContext(AuthContext);
    const startedRef = useRef(false);

    useEffect(() => {
        if (startedRef.current) return;
        startedRef.current = true;

        // This will:
        // - clear native.session
        // - clear OBO flags
        // - redirect to Entra logout via MSAL (if an MSAL account exists)
        Promise.resolve((auth as any)?.logout?.())
            .catch((e: any) => console.error("[Logout] logout failed", e));
    }, [auth]);

    return <AbpnSpinner />;
};

export default Logout;
